import { useState, useEffect } from "react";
import { getSuggestionsHits } from "@Components/search/utils/searchUtils";
import { Highlighted } from "@Components/ui/Highlighted/Highlighted";
import { hitsResHit } from "@Types/SearchUtils";
import Image from "components/Image";
import classes from "./SearchInputPredict.module.scss";

interface hitsRes {
  slice: Function;
  hits?: hitsResHit;
}

interface ISearchInputPredictProps {
  term: string;
  focused: boolean;
  onSuggestionClick: Function;
}
export default function SearchInputPredict(props: ISearchInputPredictProps) {
  const maxSuggestions = 10;

  const { term, focused, onSuggestionClick } = props;
  const validAndFocused = term.length > 2 && focused;
  const [suggestionList, setSuggestionList] = useState([]);

  const updateSuggestionTags = (hits: hitsRes) => {
    setSuggestionList(hits.slice(0, maxSuggestions));
  };

  useEffect(() => {
    if (!term || term.length < 3) {
      setSuggestionList([]);
      return;
    }

    getSuggestionsHits(term, updateSuggestionTags, false);
  }, [term]);

  return (
    <div // suggestion-tags-container
      className={classes["results"]}
      style={{
        display: validAndFocused && suggestionList.length ? "block" : "none",
      }}
      data-testid="container-autocomplete-results"
    >
      {validAndFocused ? (
        suggestionList.map((result) => (
          <div
            className={classes["item-wrapper"]}
            key={result}
            onClick={() => onSuggestionClick(result)}
            data-testid="autocomplete-result"
          >
            <div className={classes["item-result"]}>
              <Highlighted text={result} highlight={term} />
              <Image
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAA/0lEQVRIie3UPQrCMBgG4PcL5ggK3sBBKbQdnKsXsDd1E0HBySUWig7eQNADOARblzrYlv6kX0TEF7Lkh4eE8AL//HooP6GU2gOY1py7E1Hoed7KFBYlc3UoS3o162cAge/7F2647MavnACMAKzjOB58DBZCBACOAMZa651SavgR2HXdmxBiluEjAFtOvOqpreKVsE28FraFl8H3bBRwKeUcTL+9ABNRSESLss2O41yllLMMH2utN6Z4oTKbJIqifpIkGwATGJaMEcyBG8Nd8U5wF7wzbIqzwCY4G9wWZ4Xb4OxwU7xRV7dNvl6JaJnfYwUG3ur1kKbpw5bzz/fmCSnOmW1flsQGAAAAAElFTkSuQmCC"
                width={18}
                height={18}
                alt="store"
              />
            </div>
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
}
